<section class="ftco-section ftco-no-pt ftco-no-pb ftco-services-2 bg-light" style="margin: 5% 0;">
    <div class="container">

        <div class="row d-flex box-border">
            <div class="col-lg-9">
                <!-- <h2>Free <span style="color: #004aad;">COVID-19 Consultation For Indian Patients Only</span></h2> -->
                <div class="col-sm-12 heading-section text-center">
                    <h2> <span style="color: #004aad;">Free COVID-19 Consultation </span></h2>
                </div>
                <p class="center-text-p">
                    eGlobalDoctors working in association with AAPI physicians and SEWA international
                    volunteers to make this service possible.
                </p>

                <p class="center-text-p">
                    This service is not for emergencies.
                    Advise will be given by our volunteer physicians with limited
                    history and without examination.
                    Please consult your physician for full medical consultation.
                </p>
            </div>
            <div class="col-lg-3 card margin-mobile" style="flex-direction: column;font-size: 50px; color: #004aad;text-align: center; 
            margin-left: 0%;height: max-content; font-weight: bold;">
                <p style="color: black;font-size: 29px;">Patients seen so far</p>
                <p *ngIf="getBoolean(this.count_consultation)">{{this.count_consultation}}+</p>
            </div>
            <div class="col-sm-12 col-lg-3 mt-2 mb-5 centerImg">
                <img src="assets/images/special/sewa.jpg" style="width:115px;height: 105px;margin: auto;"
                    alt="Sewa International USA">
            </div>
            <div class="col-sm-12 col-lg-3 mt-2 mb-5 centerImg">
                <img src="assets/images/special/usa.png" style="width:150px;height: 90px;margin: auto;"
                    alt="American Association of Physicians of Indian Origin">
            </div>
            <div class="col-sm-12 col-lg-3 mt-2 mb-5 centerImg">
                <img src="assets/images/special/ind.png" style="width:150px;height: 90px;margin: auto;"
                    alt="Free-Covid-Consultation-For-Indian-Patients">
            </div>
            <div class="col-sm-12 col-lg-3 mt-2 mb-5 centerImg">
                <img src="assets/images/special/aapi.png" style="width:215px;height: 115px;margin: auto;"
                    alt="American Association of Physicians of Indian Origin">
            </div>

            <div class="col-sm-12 col-lg-6 mt-2 mb-5">
                <h3 style="font-weight: 800; text-align: center;">How does it work?</h3>
                <p class="center-text-p"><span style="text-decoration: underline;font-weight: 600;">Step 1:</span> Fill
                    up the COVID-19
                    registration form (<button class="ui-button-info ui-button-rounded" pButton label="Click here"
                        (click)="open_form()"></button>).
                </p>
                <p class="center-text-p">If you have problems in filling the form, please send your name, age and phone
                    to <a href="mailto:coviddoctorhelp@gmail.com">coviddoctorhelp@gmail.com</a>.
                    One of the volunteers would call and assist you to fill the form and help with telemedicine
                    consultation.
                </p>
                <p class="center-text-p"><span style="text-decoration: underline;font-weight: 600;">Step 2:</span> Click
                    on the Zoom link to
                    Join Meeting.
                </p>
                <p class="center-text-p"><span style="text-decoration: underline;font-weight: 600;">Note:</span> Doctor
                    will be assigned
                    directly if you complete Step 1. If you don’t complete Step 1, then our volunteer will help you to
                    fill out the form once you join Zoom Meeting.
                </p>
            </div>

            <div class="col-sm-12 col-lg-6 mt-2 mb-5">
                <div class="col-sm-12 col-lg-12" style="margin-top: 10%;">
                    <p class="center-red-text" style="font-weight: 800;">Click below for free consultation</p>
                    <button class="center-bttn button-glow ui-button-info ui-button-rounded" pButton
                        style="margin: auto;display: block ruby;height: 50px;" (click)="openZoomLink()">
                        <span>Join Meeting</span>
                    </button>
                </div>
                <div class="row" *ngIf="this.response_success!=null && this.response_success">
                    <div class="col-sm-12 col-lg-6" style="margin-top: 3%;border: 1px solid black;">
                        <p class="center-red-text" style="margin-top: 3%; color: #004aad; font-weight: bold;">Weekdays
                        </p>
                        <p class="center-red-text">{{this.weekdays[0][0]}} - {{this.weekdays[0][1]}} IST</p>
                        <p class="center-red-text">{{this.weekdays[1][0]}} - {{this.weekdays[1][1]}} IST</p>
                    </div>
                    <div class="col-sm-12 col-lg-6" style="margin-top: 3%;border: 1px solid black;">
                        <p class="center-red-text" style="margin-top: 3%; color: #004aad; font-weight: bold;">Weekends
                        </p>
                        <p class="center-red-text">{{this.weekends[0][0]}} - {{this.weekends[0][1]}} IST</p>
                        <p class="center-red-text">{{this.weekends[1][0]}} - {{this.weekends[1][1]}} IST</p>
                    </div>
                </div>

                <div class="col-sm-12 col-lg-12" style="margin-top: 10%;">
                    <button class="center-bttn button-glow ui-button-info " pButton
                        style="margin: auto;display: block ruby;height: 50px;"
                        (click)="openLink('PORTAL_BASE_URL',feedback_url,'_blank');">
                        <span>Leave Feedback</span>
                    </button>
                </div>

            </div>
            <div class="col-sm-12">
                <p style="float: right;margin-right: -3%;margin-bottom: -3%; font-size: 15px;"><span
                        style="color: red;">*</span><span style="text-decoration: bold;">Note:</span> Consultation For
                    Indian Patients Only</p>
            </div>
        </div>
    </div>
</section>